import { Reducer } from "redux";
import {
  TemplateState,
  TemplateActionTypes
} from "./types";

const initialState: TemplateState = {
  list: [],
  current: undefined,
  loading: false,
  error: null,
};

type Action =
  | { type: TemplateActionTypes.GET_TEMPLATES_REQUEST }
  | { type: TemplateActionTypes.GET_TEMPLATES_SUCCESS; payload: any[] }
  | { type: TemplateActionTypes.GET_TEMPLATES_ERROR; payload: string }
  | { type: TemplateActionTypes.GET_TEMPLATE_REQUEST }
  | { type: TemplateActionTypes.GET_TEMPLATE_SUCCESS; payload: any }
  | { type: TemplateActionTypes.GET_TEMPLATE_ERROR; payload: string }
  | { type: TemplateActionTypes.CREATE_TEMPLATE_REQUEST }
  | { type: TemplateActionTypes.CREATE_TEMPLATE_SUCCESS; payload: any }
  | { type: TemplateActionTypes.CREATE_TEMPLATE_ERROR; payload: string }
  | { type: TemplateActionTypes.UPDATE_TEMPLATE_REQUEST }
  | { type: TemplateActionTypes.UPDATE_TEMPLATE_SUCCESS; payload: any }
  | { type: TemplateActionTypes.UPDATE_TEMPLATE_ERROR; payload: string }
  | { type: TemplateActionTypes.DELETE_TEMPLATE_REQUEST }
  | { type: TemplateActionTypes.DELETE_TEMPLATE_SUCCESS; payload: string }
  | { type: TemplateActionTypes.DELETE_TEMPLATE_ERROR; payload: string };

const reducer: Reducer<TemplateState, Action> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case TemplateActionTypes.GET_TEMPLATES_REQUEST:
    case TemplateActionTypes.GET_TEMPLATE_REQUEST:
    case TemplateActionTypes.CREATE_TEMPLATE_REQUEST:
    case TemplateActionTypes.UPDATE_TEMPLATE_REQUEST:
    case TemplateActionTypes.DELETE_TEMPLATE_REQUEST:
      return { ...state, loading: true, error: null };

    case TemplateActionTypes.GET_TEMPLATES_SUCCESS:
      return { ...state, loading: false, list: action.payload };

    case TemplateActionTypes.GET_TEMPLATE_SUCCESS:
      return { ...state, loading: false, current: action.payload };

    case TemplateActionTypes.CREATE_TEMPLATE_SUCCESS:
    case TemplateActionTypes.UPDATE_TEMPLATE_SUCCESS:
      return { ...state, loading: false };

    case TemplateActionTypes.DELETE_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        list: state.list.filter((t) => t.id !== action.payload),
        current:
          state.current?.id === action.payload ? undefined : state.current,
      };

    case TemplateActionTypes.GET_TEMPLATES_ERROR:
    case TemplateActionTypes.GET_TEMPLATE_ERROR:
    case TemplateActionTypes.CREATE_TEMPLATE_ERROR:
    case TemplateActionTypes.UPDATE_TEMPLATE_ERROR:
    case TemplateActionTypes.DELETE_TEMPLATE_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};


export { reducer as TemplateReducer };
